import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

const GOBLIN_COLORS = {
  body: PRIMITIVE_COLORS.green,
  border: PRIMITIVE_COLORS.darkSlate,
  eye: PRIMITIVE_COLORS.lightYellow,
  pupil: PRIMITIVE_COLORS.darkSlate,
  tooth: PRIMITIVE_COLORS.white,
  belt: PRIMITIVE_COLORS.darkSlate,
  buckle: PRIMITIVE_COLORS.lightYellow,
  shadow: PRIMITIVE_COLORS.darkSlate,
};

export const GOBLIN_BLUEPRINT: PrimitiveBlueprint = {
  id: "goblin",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.1, y: 0.82, w: 0.8, h: 0.16 },
      style: { fill: GOBLIN_COLORS.shadow, fillAlpha: 0.35 },
      z: 0,
    },
    {
      id: "body",
      type: "roundRect",
      bounds: { x: 0.12, y: 0.12, w: 0.76, h: 0.68 },
      style: {
        fill: GOBLIN_COLORS.body,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 4,
      },
      z: 1,
    },
    {
      id: "ear-left",
      type: "triangle",
      bounds: { x: 0.02, y: 0.0, w: 0.24, h: 0.22 },
      style: {
        fill: GOBLIN_COLORS.body,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 3,
      },
      z: 1,
    },
    {
      id: "ear-right",
      type: "triangle",
      bounds: { x: 0.74, y: 0.02, w: 0.24, h: 0.22 },
      style: {
        fill: GOBLIN_COLORS.body,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 3,
      },
      z: 1,
    },
    {
      id: "eye-left",
      type: "ellipse",
      bounds: { x: 0.3, y: 0.34, w: 0.16, h: 0.12 },
      style: {
        fill: GOBLIN_COLORS.eye,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 2,
    },
    {
      id: "eye-right",
      type: "ellipse",
      bounds: { x: 0.54, y: 0.34, w: 0.16, h: 0.12 },
      style: {
        fill: GOBLIN_COLORS.eye,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 2,
    },
    {
      id: "pupil-left",
      type: "ellipse",
      bounds: { x: 0.34, y: 0.36, w: 0.08, h: 0.08 },
      style: { fill: GOBLIN_COLORS.pupil },
      z: 3,
    },
    {
      id: "pupil-right",
      type: "ellipse",
      bounds: { x: 0.58, y: 0.36, w: 0.08, h: 0.08 },
      style: { fill: GOBLIN_COLORS.pupil },
      z: 3,
    },
    {
      id: "belt",
      type: "rect",
      bounds: { x: 0.14, y: 0.58, w: 0.72, h: 0.12 },
      style: {
        fill: GOBLIN_COLORS.belt,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 4,
    },
    {
      id: "buckle",
      type: "rect",
      bounds: { x: 0.44, y: 0.58, w: 0.12, h: 0.12 },
      style: {
        fill: GOBLIN_COLORS.buckle,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 5,
    },
    {
      id: "tooth-left",
      type: "triangle",
      bounds: { x: 0.38, y: 0.52, w: 0.08, h: 0.08 },
      style: {
        fill: GOBLIN_COLORS.tooth,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 5,
    },
    {
      id: "tooth-right",
      type: "triangle",
      bounds: { x: 0.52, y: 0.52, w: 0.08, h: 0.08 },
      style: {
        fill: GOBLIN_COLORS.tooth,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 5,
    },
    {
      id: "tooth-center",
      type: "triangle",
      bounds: { x: 0.45, y: 0.5, w: 0.1, h: 0.08 },
      style: {
        fill: GOBLIN_COLORS.tooth,
        stroke: GOBLIN_COLORS.border,
        strokeWidth: 2,
      },
      z: 5,
    },
    {
      id: "brow",
      type: "line",
      bounds: { x: 0.28, y: 0.32, w: 0.48, h: 0.02 },
      style: { stroke: GOBLIN_COLORS.border, strokeWidth: 3 },
      z: 6,
    },
  ],
};
